import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const surveyAnswer = async (params: object) => {
  return await POST({
    url: Api.surveyAnswer,
    data: params.survey,
    showError: false
  })
}
